import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { NAVBAR_ICON_URL } from '../../constants';
import styles from './Authentication.module.css';
import { AuthenticationDialog, ModeType } from './auth/AuthenticationDialog';
import config from '../../config';

export const AuthenticationView = ({ onSuccess }: AuthenticationViewProps) => {
	const [, setSearchParams] = useSearchParams();
	const [isOpen, setIsOpen] = useState(false);
	const [mode, setMode] = useState<ModeType>('login');
	useEffect(() => {
		const updatedSearchParams = new URLSearchParams();
		setSearchParams(updatedSearchParams.toString());
	}, []);
	const onCloseDialog = () => {
		setIsOpen(false);
	};
	const onClickSignIn = () => {
		setIsOpen(true);
		setMode('login');
	};
	const onClickSignUp = () => {
		if (config?.app?.auth?.type === 'cognito') {
			const auth = config.app.auth;
			return;
		}
		const registerUrl = config.build?.links?.register;
		if (registerUrl) {
			open(registerUrl, '_blank');
		}

		// setIsOpen(false);
		/*if (config.build.title === 'Yummy') {
			open('https://club.yummy.men/', '_blank');
		}
		open('https://www.pw.org/user/register', '_blank');*/
		// setIsOpen(false);
		// setMode('signup');
	};
	const classNames = [styles['view']];
	if (isOpen) {
		classNames.push(styles['dialog-open']);
	}
	return (
		<div className={classNames.join(' ')}>
			<Wrapper
				onClickSignIn={onClickSignIn}
				onClickSignUp={onClickSignUp}
			/>

			<AuthenticationDialog
				mode={mode}
				setMode={setMode}
				onClickSignUp={onClickSignUp}
				onClickLogIn={onClickSignIn}
				onCloseDialog={onCloseDialog}
				isOpen={isOpen}
				onSuccess={onSuccess}
			/>
		</div>
	);
};

interface AuthenticationViewProps {
	onSuccess: () => void;
}

const Wrapper = ({ onClickSignIn, onClickSignUp }: WrapperProps) => {
	let registerBtn = null;
	if (config?.build?.links?.register) {
		registerBtn = <button onClick={onClickSignUp}>Register</button>;
	}

	return (
		<div className={styles['wrapper']}>
			<div>
				<h2>Welcome!</h2>
				<img
					className={styles['logo']}
					alt="logo"
					src={NAVBAR_ICON_URL}
				/>
				<button onClick={onClickSignIn}>Sign In</button>
				{registerBtn}
				{config?.build?.links?.forgotPassword ? (
					<small>
						<a
							rel="noreferrer"
							href={config?.build?.links?.forgotPassword}
							target="_blank"
						>
							Forgot password?
						</a>
					</small>
				) : null}
			</div>
		</div>
	);
};

interface WrapperProps {
	onClickSignIn: () => void;
	onClickSignUp: () => void;
}
